import { render, staticRenderFns } from "./StudyNew.vue?vue&type=template&id=d35e859a"
import script from "./StudyNew.vue?vue&type=script&lang=js"
export * from "./StudyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports